import { c as _c } from "react/compiler-runtime";
import { type ListingType } from '@/features/listing/types/listing-types';
import HaveApartmentIcon from '@/ui/svg/service-types/haveapartment.svg';
import HaveShareIcon from '@/ui/svg/service-types/haveshare.svg';
import NeedApartmentIcon from '@/ui/svg/service-types/needapartment.svg';
import NeedRoomIcon from '@/ui/svg/service-types/needroom.svg';
interface ListingTypeSvgProps {
  type: ListingType;
}
export default function ListingTypeSvg(props) {
  const $ = _c(13);
  const {
    type
  } = props;
  let t0;
  if ($[0] !== type) {
    t0 = type === "haveshare" && <HaveShareIcon />;
    $[0] = type;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== type) {
    t1 = type === "haveapartment" && <HaveApartmentIcon />;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== type) {
    t2 = type === "needapartment" && <NeedApartmentIcon />;
    $[4] = type;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== type) {
    t3 = type === "needroom" && <NeedRoomIcon />;
    $[6] = type;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <>{t0}{t1}{t2}{t3}</>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}